import { useFilter } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'

import { compactString } from './string'
import { isObject } from 'lodash'
import { genRelativeDateValues } from './date'

export const useFilterValueText = field => {
  const { t } = useTranslation()
  const filter = useFilter() || {}
  let value = filter[field]

  if (isObject(value)) {
    value = genRelativeDateValues(value)
  }

  return compactString(value, { t: t, tField: field })
}
